import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox } from '@els/els-react--checkbox';
import InnerHTML from '@Components/InnerHTML';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import './SuggestModalContent.scss';

const spinnerId = 'suggestModal';

function SuggestModalContent({ isLoading, noData, opModel, pushToSelected, expandedValue }) {
  const handleItemSelection = (item) => {
    pushToSelected({ ...item, isSelected: !item.isSelected });
  };

  if (noData) {
    return (
      <div className="suggestModal__content">
        {isLoading && <SimpleSpinner id={spinnerId} />}
        {!isLoading && <div>No data from expand</div>}
      </div>
    );
  }

  const formatTitle = (title) => {
    let result = title;
    if (title.length > 90) {
      result = `${title.substr(0, 45)}...${title.substr(-45)}`;
    }
    return <InnerHTML tag="span" html={result} />;
  };

  // eslint-disable-next-line sonarjs/slow-regex
  const formatCount = (count) => String(count.toFixed().toLocaleString()).replace(/(.)(?=(\d{3})+$)/g, '$1,');

  if (isLoading) {
    return (
      <div className="suggest-modal-content-wrapper u-els-margin-top">
        <SimpleSpinner id={spinnerId} />
      </div>
    );
  }
  return (
    <div className="suggest-modal-content-wrapper u-els-margin-top">
      {opModel.groups.map((item, index) => (
        <div
          className={classnames('list__item u-els-padding-top-1o2 u-els-padding-bottom-1o2 u-els-padding-right', {
            list__item_highlighted: expandedValue && item.title === expandedValue,
          })}
          // eslint-disable-next-line react/no-array-index-key
          key={`suggest-item-${index}-${item.displayTitle}`}>
          <div className="list__item_checkbox">
            <Checkbox
              data-e2e={`suggest-item-checkbox-${item.displayTitle}`}
              checked={item.isSelected}
              onChange={() => handleItemSelection(item)}
              label={formatTitle(item.displayTitle)}
              aria-checked={item.isSelected}
            />
          </div>
          <div className="list__item_count">{formatCount(item.count)}</div>
        </div>
      ))}
    </div>
  );
}

SuggestModalContent.propTypes = {
  isLoading: PropTypes.bool,
  noData: PropTypes.bool,
  opModel: PropTypes.object,
  pushToSelected: PropTypes.func.isRequired,
  expandedValue: PropTypes.string,
};

export default SuggestModalContent;
